const watermark = {
  inserted(el, binding) {
    const { text, font, textColor } = binding.value || {};
    
    // 生成水印唯一ID
    const watermarkId = 'wm_' + Math.random().toString(36).substr(2, 9);
    const watermarkDiv = document.createElement('div');
    watermarkDiv.className = 'watermark-container';
    watermarkDiv.dataset.watermarkId = watermarkId;
    
    // 生成水印图片URL
    const watermarkUrl = generateWatermark(text, font, textColor);
    
    // 关键样式设置 - 修复显示问题
    const initialStyles = {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      minWidth: '100%',   // 防止宽度被缩小
      minHeight: '100%',  // 防止高度被缩小
      pointerEvents: 'none', // 允许事件穿透
      backgroundRepeat: 'repeat',
      backgroundImage: watermarkUrl,
      zIndex: '2147483647',
      display: 'block',
      visibility: 'visible',
      opacity: '0.2' // 确保透明度可显示
    };
    
    // 应用初始样式
    Object.assign(watermarkDiv.style, initialStyles);
    
    // 保护水印元素
    protectWatermark(watermarkDiv, el, initialStyles, watermarkUrl);
    
    // 设置父元素为相对定位
    if (window.getComputedStyle(el).position === 'static') {
      el.style.position = 'relative';
    }
    
    el.appendChild(watermarkDiv);
  }
};

function generateWatermark(text = '水印', font = '16px Microsoft YaHei', color = 'rgba(180, 180, 180, 0.3)') {
  const canvas = document.createElement('canvas');
  canvas.width = 220;
  canvas.height = 180;
  
  const ctx = canvas.getContext('2d');
  ctx.rotate(-20 * Math.PI / 180);
  ctx.font = font;
  ctx.fillStyle = color;
  ctx.textAlign = 'left';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, canvas.width / 6, canvas.height / 3);
  
  // 添加干扰线
  ctx.strokeStyle = 'rgba(200, 200, 200, 0.08)';
  ctx.beginPath();
  ctx.moveTo(0, canvas.height / 2);
  ctx.lineTo(canvas.width, canvas.height / 2);
  ctx.stroke();
  
  return `url(${canvas.toDataURL('image/png')})`;
}

function protectWatermark(element, parent, initialStyles, watermarkUrl) {
  // 存储初始属性值
  const storedValues = {
    backgroundImage: watermarkUrl,
    zIndex: initialStyles.zIndex,
    position: initialStyles.position,
    display: initialStyles.display,
    width: initialStyles.width,
    height: initialStyles.height,
    minWidth: initialStyles.minWidth,
    minHeight: initialStyles.minHeight,
    pointerEvents: initialStyles.pointerEvents
  };
  
  // 1. 防删除保护
  const deleteObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((node) => {
        if (node === element || node.dataset?.watermarkId === element.dataset.watermarkId) {
          parent.appendChild(element);
          console.warn('水印元素被删除，已自动恢复');
        }
      });
    });
  });
  
  deleteObserver.observe(parent, { childList: true });
  
  // 2. 防属性篡改保护 - 修复检测逻辑
  const attributeObserver = new MutationObserver(() => {
    let needsReset = false;
    const computedStyle = window.getComputedStyle(element);
    
    // 修复：只检查关键属性，不过度干扰
    // 显示属性检测
    if (computedStyle.display === 'none' || 
        computedStyle.visibility === 'hidden') {
      element.style.display = storedValues.display;
      element.style.visibility = 'visible';
      needsReset = true;
    }
    
    // 修复：放宽透明度检测阈值
    if (parseFloat(computedStyle.opacity) < 0.05) {
      element.style.opacity = '0.3';
      needsReset = true;
    }
    
    // 修复：位置属性检测更宽松
    const isPositionValid = computedStyle.position === 'absolute' &&
                           computedStyle.top === '0px' &&
                           computedStyle.left === '0px';
    
    if (!isPositionValid) {
      element.style.position = storedValues.position;
      element.style.top = '0';
      element.style.left = '0';
      needsReset = true;
    }
    
    // 修复：背景图检测更智能
    const cleanUrl = watermarkUrl.replace(/["']/g, '');
    if (!computedStyle.backgroundImage.includes(cleanUrl)) {
      element.style.backgroundImage = storedValues.backgroundImage;
      needsReset = true;
    }
    
    // 修复：z-index检测阈值调整
    if (parseInt(computedStyle.zIndex) < 1000000) {
      element.style.zIndex = storedValues.zIndex;
      needsReset = true;
    }
    
    // 尺寸保护检测
    const sizeProps = ['width', 'height', 'minWidth', 'minHeight'];
    sizeProps.forEach(prop => {
      // 修复：只检测明显篡改值
      if (computedStyle[prop] === '0px' || 
          computedStyle[prop] === '1px' || 
          computedStyle[prop] === '0%') {
        element.style[prop] = storedValues[prop];
        needsReset = true;
      }
    });

    if (needsReset) {
      console.warn('检测到水印属性篡改，已自动恢复');
    }
  });
  
  attributeObserver.observe(element, { 
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  // 3. 定时检查（修复过度检查问题）
  const checkInterval = setInterval(() => {
    // 元素存在检查
    if (!document.body.contains(element)) {
      parent.appendChild(element);
      console.warn('水印元素被移除，已重新添加');
      return;
    }
    
    // 修复：只在需要时检查尺寸
    const computedStyle = window.getComputedStyle(element);
    if (parseInt(computedStyle.width) < 10 || parseInt(computedStyle.height) < 10) {
      element.style.width = storedValues.width;
      element.style.height = storedValues.height;
      console.warn('检测到水印尺寸过小，已重置');
    }
    
    // 修复：父元素定位检查
    const parentStyle = window.getComputedStyle(parent);
    if (parentStyle.position === 'static') {
      parent.style.position = 'relative';
    }
  }, 3000); // 降低检查频率
    
  // 存储清理函数
  element.cleanupWatermark = () => {
    deleteObserver.disconnect();
    attributeObserver.disconnect();
    clearInterval(checkInterval);
  };
}

// 添加卸载清理
watermark.unbind = (el) => {
  const watermark = el.querySelector('.watermark-container');
  if (watermark && watermark.cleanupWatermark) {
    watermark.cleanupWatermark();
  }
};

export default watermark;